module.exports = __webpack_public_path__ + "media/dashboard/components/widgets/conversation/icon/cursor-9b4828ef09ba14e12bfb0a3e9a08c06e.svg";